<div class="atn-mosaic-dev-variables-builder">
  @if (!focusedVariableDefinitionSg()) {
    <div class="atn-mosaic-dev-variables-builder__table">
      <atn-variables-table />
    </div>
  } @else {
    <div class="atn-mosaic-dev-variables-builder__variable">
      <atn-variable />
      <div class="atn-mosaic-dev-variables-builder__variable-buttons">
        <atn-ds-button
          type="transparent"
          (click)="cancelClickHandler()"
          >Cancel</atn-ds-button
        >
        <atn-ds-button (click)="saveClickHandler()">{{
          isUpdatingSg() ? 'Update' : 'Add'
        }}</atn-ds-button>
      </div>
    </div>
  }
</div>
